import React, { FC, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import useOutsideClick from "hooks/click-outside";
import { ReactComponent as Arrow } from "assets/images/svgs/ambassador/arrow-right.svg";
import PhotoOfNewBusiness from "./photo-of-new-business-commitment";
import GoalOfNewBusiness from "./business-registration-goal";
import SupportOfNewBusiness from "./support-for-experience-creation";
import AmbassadorExperiencesFollow from "./experiences";
import NewPost from "./new-post";
import useStore from "hooks/useStore";
import { siteRoutes } from "utils/helpers/enums/routes";
import { useNavigate } from "react-router-dom";

interface SocialMediaActivityProps {
  isOpen: boolean;
  handleConfirm: () => void;
  onClose: () => void;
}

const BusinessEngagement: FC<SocialMediaActivityProps> = ({
  isOpen,
  onClose,
  handleConfirm,
}) => {
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [showGoalModal, setShowGoalModal] = useState(false);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [showAmbassadorExperiences, setShowAmbassadorExperiences] = useState(false);
  const { getAmbassadorTierResposibilities } = useStore()
  const ambassadorTierResposibilities = getAmbassadorTierResposibilities();
  const navigate = useNavigate()
  const modalRef = useOutsideClick(() => {
    if (
      isOpen &&
      !showPhotoModal &&
      !showGoalModal &&
      !showSupportModal &&
      !showAmbassadorExperiences
    ) {
      onClose();
    }
  });

  const handlePhotoClick = () => setShowPhotoModal(true);
  const handleGoalClick = () => setShowGoalModal(true);
  const handleSupportClick = () => setShowSupportModal(true);

  const handleShareClick = () => {
    // setShowAmbassadorExperiences(true);
   navigate(siteRoutes.ambassadorfollowExperiences)
  };

  const options = [
    {
      label: "Photo of New Business Commitment",
      label1: ambassadorTierResposibilities?.businessEngagement
        ? `${ambassadorTierResposibilities.businessEngagement.commitment.quantity} business that verbally commits to join Learn Local`
        : "business that verbally commits to join Learn Local",
      onClick: handlePhotoClick,
    },
    {
      label: "Business Registration Goal",
      label1: ambassadorTierResposibilities?.businessEngagement
        ? `Help ${ambassadorTierResposibilities.businessEngagement.businessRegistration.quantity} business complete its profile`
        : "",
      onClick: handleGoalClick,
    },
    {
      label: "Support for Experience Creation",
      label1: ambassadorTierResposibilities?.businessEngagement
        ? `${ambassadorTierResposibilities.businessEngagement.experienceCreation.quantity} Initial consultation or support session`
        : "",
      onClick: handleSupportClick,
    },
    {
      label: "Follow-Up After Experience",
      label1: ambassadorTierResposibilities?.businessEngagement
        ? `Follow up with ${ambassadorTierResposibilities.businessEngagement.followUpAfterExperience.quantity} business`
        : "",
      onClick: handleShareClick,
    },
  ];


  if (
    !isOpen &&
    !showPhotoModal &&
    !showGoalModal &&
    !showSupportModal &&
    !showAmbassadorExperiences
  )
    return null;

  return (
    <>
      {isOpen &&
        !showPhotoModal &&
        !showGoalModal &&
        !showSupportModal &&
        !showAmbassadorExperiences && (
          <div
            className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
              isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
            style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
          >
            <div
              ref={modalRef}
              className={`relative bg-white px-4 sm:px-6 md:px-10 py-6 sm:py-8 md:py-12 rounded-lg shadow-lg w-[90%] sm:w-[500px] md:w-[550px] transform transition-transform duration-300 ${
                isOpen ? "scale-100" : "scale-95"
              }`}
            >
              {/* Close Button */}
              <button
                onClick={onClose}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
              >
                <AiOutlineClose size={20} />
              </button>

              <h2 className="text-xl sm:text-2xl font-bold text-center mb-2 text-rsvpBlackie">
                Business Engagement
              </h2>
              <p className="text-center text-sm sm:text-base md:text-lg text-rsvpBlackie mb-6 sm:mb-8">
                Spread the Learn Local message with Business Engagement
              </p>

              <div className="space-y-3 mb-6">
                {options.map((item, index) => (
                  <button
                    key={index}
                    onClick={item.onClick}
                    className="w-full flex items-center justify-between bg-[#F8F8F8] px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl hover:bg-[#E8E8E8] transition"
                  >
                    <div className="flex flex-col text-left flex-1 pr-2">
                      <span className="text-base sm:text-lg font-semibold text-rsvpBlackie">
                        {item.label}
                      </span>
                      <span className="text-xs sm:text-sm text-rsvpBlackie mt-1">
                        {item.label1}
                      </span>
                    </div>
                    <Arrow className="w-6 h-6 sm:w-8 sm:h-8 flex-shrink-0" />
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

      {/* {showPhotoModal && (
        <PhotoOfNewBusiness
          isOpen={showPhotoModal}
          onClose={() => {
            setShowPhotoModal(false);
            onClose();
          }}
          handleConfirm={handleConfirm}
        />
      )} */}
      {showPhotoModal && (
        <NewPost
          isOpen={showPhotoModal}
          onClose={() => {
            setShowPhotoModal(false);
            onClose();
          }}
          handleConfirm={handleConfirm}
          title="Photo of New Business"
        />
      )}

      {showGoalModal && (
        <GoalOfNewBusiness
          isOpen={showGoalModal}
          onClose={() => {
            setShowGoalModal(false);
            onClose();
          }}
          handleConfirm={handleConfirm}
        />
      )}

      {showSupportModal && (
        <SupportOfNewBusiness
          isOpen={showSupportModal}
          onClose={() => {
            setShowSupportModal(false);
            onClose();
          }}
          handleConfirm={handleConfirm}
        />
      )}

      {/* {showAmbassadorExperiences && (
        <div className="fixed z-50 inset-0 bg-white overflow-y-auto">
          <AmbassadorExperiencesFollow />
        </div>
      )} */}
    </>
  );
};

export default BusinessEngagement;
